/*
 * Interface strings for the "discovery" area. Keys are the Russian source strings exactly as they
 * appear in the components; a missing key falls back to Russian, so a partial dictionary is safe.
 * Russian itself is never listed here — it is the key.
 */
const discovery = {
  english: {
    /* PaymentPage */
    'Промокод не найден': 'Promo code not found',
    '+{0} звёзд зачислено!': '+{0} stars added!',
    'Реклама недоступна. Попробуйте позже.': 'Ads are unavailable. Please try again later.',
    'Не удалось запустить рекламу': "Couldn't start the ad",
    'Нет доступной рекламы. Попробуйте позже.': 'No ads available right now. Please try again later.',
    '+{0} звёзд! Спасибо за просмотр.': '+{0} stars! Thanks for watching.',
    'Не удалось начислить звёзды': "Couldn't credit your stars",
    'Промокод больше не действителен — скидка сброшена': 'This promo code is no longer valid — the discount has been removed',
    'Загрузка…': 'Loading…',
    'Ошибка загрузки данных': 'Failed to load data',
    'На главную': 'Home',
    'Профиль': 'Profile',
    'Пополнить счёт': 'Top up balance',
    'Баланс': 'Balance',
    'звёзд': 'stars',
    '💬 Каждое сообщение персонажам стоит минимум 10 звёзд': '💬 Every message to a character costs at least 10 stars',
    'Бесплатные звёзды': 'Free stars',
    'Посмотрите рекламу и получите 1 звезду': 'Watch an ad and get 1 star',
    'Только для зарегистрированных пользователей': 'Registered users only',
    'Смотреть рекламу': 'Watch ad',
    'Промокод': 'Promo code',
    'Введи промокод — получи скидку или звёзды': 'Enter a promo code — get a discount or stars',
    'Введи промокод': 'Enter promo code',
    'Только для зарегистрированных': 'Registered users only',
    'Убрать': 'Remove',
    'Применить': 'Apply',
    '🎉 Скидка {0}% применена к ценам ниже!': '🎉 {0}% discount applied to the prices below!',
    'Пакеты': 'Packages',
    'Быстрая покупка': 'Quick purchase',
    'руб.': 'RUB',
    '{0} звёзд': '{0} stars',
    '{0} ходов': '{0} turns',
    '{0} руб./ход': '{0} RUB/turn',
    'до {0} сообщений персонажам': 'up to {0} messages to characters',
    'от {0} за сообщение': 'from {0} per message',
    'Переход к оплате…': 'Going to checkout…',
    'Купить': 'Buy',
    'Войдите для покупки': 'Sign in to buy',
    'Пополняя счёт, вы соглашаетесь с условиями оказания услуг, размещёнными в': 'By topping up your balance, you agree to the terms of service set out in the',
    'Пользовательском соглашении': 'User Agreement',
    'История платежей': 'Payment history',
    '+{0} звёзд': '+{0} stars',

    /* AuthorsPage */
    '{0} — отличная возможность начать монетизировать своё творчество. Создавай увлекательные истории, в которые будут играть тысячи пользователей по всему миру.': '{0} is your chance to start earning from your creativity. Write gripping stories that thousands of players around the world will experience.',
    'Стать автором — AI Novel': 'Become an Author — AI Novel',
    'Стань автором интерактивных новелл с ИИ': 'Become an author of AI-powered interactive novels',
    'Начать создавать': 'Start creating',
    'Узнать больше': 'Learn more',
    'Твой творческий потенциал — твой доход': 'Your creativity, your income',
    'Каждая успешная новелла приносит автору': 'Every successful novel earns its author',
    '20% от дохода': '20% of revenue',
    'и': 'and',
    '20 000 звёзд': '20,000 stars',
    'за каждую опубликованную новеллу. Чем популярнее твоя история — тем больше заработок.': 'for every published novel. The more popular your story, the more you earn.',
    'от дохода': 'of revenue',
    'за публикацию': 'per release',
    'тыс. пользователей': 'thousand users',
    'поддержка': 'support',
    'Преимущества': 'Benefits',
    'Почему авторы выбирают {0}': 'Why authors choose {0}',
    'Мы создали все условия, чтобы ты мог полностью сосредоточиться на творчестве': 'We take care of everything else so you can focus purely on writing',
    'Выгодные условия': 'Rewarding terms',
    'Получай 20% от дохода и 20 000 звёзд за каждую опубликованную новеллу. Чем популярнее твой контент — тем выше твой заработок без ограничений.': 'Earn 20% of revenue plus 20,000 stars for every novel you publish. The more popular your work, the more you make — with no cap.',
    'Обучение и поддержка': 'Training and support',
    'Расскажем, научим и поможем разобраться с конструктором. Персональное сопровождение до выхода твоей первой новеллы.': "We'll show you the ropes and help you master the editor. Personal guidance all the way to your first release.",
    'Современные инструменты': 'Modern tools',
    'Предоставим доступ к удобному конструктору и всем необходимым сервисам для создания интерактивных новелл.': 'You get access to a comfortable editor and every service you need to build interactive novels.',
    'Творческое сообщество': 'A creative community',
    'Присоединяйся к сообществу авторов {0}. Обменивайся опытом, получай обратную связь и вдохновляйся работами коллег.': "Join the {0} authors' community. Swap ideas, get feedback and find inspiration in your peers' work.",
    'Прозрачные правила': 'Transparent rules',
    'Чёткие и понятные условия сотрудничества. Никаких скрытых комиссий — ты всегда знаешь, сколько зарабатываешь.': 'Clear, straightforward terms. No hidden fees — you always know exactly what you earn.',
    'Быстрый старт': 'A fast start',
    'Уже через пару недель ты можешь опубликовать свою первую новеллу. Мы сопровождаем автора на каждом этапе.': "You can publish your first novel in a couple of weeks. We're with you at every step.",
    'Требования': 'Requirements',
    'Кого мы ищем': "Who we're looking for",
    'Мы ценим творческих людей, готовых учиться и развиваться': 'We value creative people who are eager to learn and grow',
    'Грамотность': 'Strong writing',
    'Умение писать грамотно и складно — основа любой истории. Мы ценим чистый язык и выразительный стиль.': 'Clean, fluent writing is the backbone of any story. We value a clear voice and an expressive style.',
    'Адекватность': 'Easy to work with',
    'Умение работать в команде, принимать обратную связь и конструктивно общаться — ключ к успешному сотрудничеству.': 'Teamwork, an open mind about feedback and constructive communication make the collaboration work.',
    'Желание учиться': 'Willingness to learn',
    'Готовность разобраться с конструктором и освоить новые инструменты. ПК или ноутбук обязателен для работы.': 'Ready to dig into the editor and pick up new tools. A desktop or laptop is required.',
    'Мы поможем!': "We've got your back!",
    'Полная поддержка на протяжении всего времени': 'Full support from start to finish',
    'Расскажем и покажем, как работает конструктор': "We'll walk you through the editor",
    'Научим создавать интерактивные ветвления': "We'll teach you to build branching stories",
    'Предоставим доступ ко всем сервисам': "We'll give you access to every service",
    'Сопроводим до выхода новеллы': "We'll stay with you until release",
    'Поддержим на каждом этапе': "We'll support you at every step",
    'Готов начать свой путь автора?': 'Ready to start your author journey?',
    'Напиши нам — ответим в течение 24 часов': 'Drop us a line — we reply within 24 hours',
    'Заполнить форму': 'Fill out the form',

    /* ProductionNovelPlay */
    'Читать далее': 'Read more',
    'Новелла не найдена': 'Novel not found',
    'Ошибка загрузки': 'Loading error',
    'Только зарегистрированные пользователи могут лайкать новеллы.': 'Only registered users can like novels.',
    'Только зарегистрированные пользователи могут оставлять комментарии.': 'Only registered users can leave comments.',
    'Только зарегистрированные пользователи могут ставить лайки.': 'Only registered users can leave likes.',
    'Только зарегистрированные пользователи могут отвечать на комментарии.': 'Only registered users can reply to comments.',
    'Удалить новеллу? Это действие нельзя отменить.': "Delete this novel? This can't be undone.",
    'Ошибка при удалении новеллы.': 'Failed to delete the novel.',
    'Удаление…': 'Deleting…',
    'Поиск': 'Search',
    'Играй в интерактивную новеллу «{0}» с ИИ-персонажами на {1}.': 'Play the interactive novel “{0}” with AI-driven characters on {1}.',
    'Убрать лайк': 'Unlike',
    'Нравится': 'Like',
    'Играть': 'Play',
    'Комментарии': 'Comments',
    'Напишите комментарий…': 'Write a comment…',
    'Отправка…': 'Sending…',
    'Отправить': 'Send',
    'Пока нет комментариев. Будьте первым!': 'No comments yet. Be the first!',
    'Ответить': 'Reply',
    'Удалить': 'Delete',
    'Ответить {0}…': 'Reply to {0}…',
    'Отмена': 'Cancel',
    '▲ Скрыть ответы': '▲ Hide replies',
    '▼ Показать ответы ({0})': '▼ Show replies ({0})',
    'Ошибка': 'Error',

    /* LibraryNovelDetail */
    'Ошибка при загрузке новеллы': 'Failed to load the novel',
    'Биография успешно обновлена': 'Biography updated',
    'Удалить новеллу из библиотеки?': 'Remove this novel from your library?',
    'Новелла удалена из библиотеки': 'Novel removed from your library',
    'В библиотеку': 'To library',
    'Начать новую игру? Текущий прогресс будет сброшен.': 'Start a new game? Your current progress will be reset.',
    'Играй в интерактивную новеллу «{0}» с персонажами на основе искусственного интеллекта.': 'Play the interactive novel “{0}” with characters powered by artificial intelligence.',
    'Библиотека': 'Library',
    'Биография персонажа': "Your character's biography",
    'Имя персонажа': 'Character name',
    'Введите имя…': 'Enter a name…',
    'Биография': 'Biography',
    'Расскажите о своём персонаже…': 'Tell us about your character…',
    'Сохранить': 'Save',
    'Имя': 'Name',
    'Не задано': 'Not set',
    'Не задана': 'Not set',
    'Редактировать': 'Edit',
    'Продолжить': 'Continue',
    'Сохранения': 'Saves',
    'Новая игра': 'New game',
    'Сохранений не найдено': 'No saves yet',
    'Загрузить': 'Load',

    /* SearchPage */
    'Ошибка при загрузке новелл': 'Failed to load novels',
    'Каталог новелл — AI Novel': 'Novel catalogue — AI Novel',
    'Каталог интерактивных визуальных новелл с ИИ. Выбирай и играй в новеллы, где персонажи отвечают с помощью искусственного интеллекта.': 'A catalogue of AI-powered interactive visual novels. Pick a story and play — every character answers you through artificial intelligence.',
    'AI Novel — каталог интерактивных новелл': 'AI Novel — a catalogue of interactive novels',
    'Поиск новелл': 'Find a novel',
    'Название': 'Title',
    'Поиск по названию…': 'Search by title…',
    'Сортировка': 'Sort by',
    'Популярные': 'Popular',
    'Старые': 'Oldest',
    'Новые': 'Newest',
    'Сбросить': 'Reset',
    'Новеллы не найдены': 'No novels found',

    /* LibraryPage */
    'Ошибка при загрузке библиотеки': 'Failed to load your library',
    'Моя библиотека': 'My library',
    'Библиотека ваших интерактивных новелл. Возобновляйте прохождение, управляйте сохранениями и следите за историей своих игр.': 'Your personal library of interactive novels. Pick up where you left off, manage your saves and follow your play history.',
    'В вашей библиотеке пока нет новелл': 'Your library is empty for now',

    /* NovelCard */
    'Только зарегистрированные пользователи могут лайкать новеллы. Пожалуйста, создайте аккаунт.': 'Only registered users can like novels. Please create an account.',
  },

  german: {
    /* PaymentPage */
    'Промокод не найден': 'Promocode nicht gefunden',
    '+{0} звёзд зачислено!': '+{0} Sterne gutgeschrieben!',
    'Реклама недоступна. Попробуйте позже.': 'Werbung ist nicht verfügbar. Bitte später erneut versuchen.',
    'Не удалось запустить рекламу': 'Werbung konnte nicht gestartet werden',
    'Нет доступной рекламы. Попробуйте позже.': 'Derzeit ist keine Werbung verfügbar. Bitte später erneut versuchen.',
    '+{0} звёзд! Спасибо за просмотр.': '+{0} Sterne! Danke fürs Zuschauen.',
    'Не удалось начислить звёзды': 'Sterne konnten nicht gutgeschrieben werden',
    'Промокод больше не действителен — скидка сброшена': 'Dieser Promocode ist nicht mehr gültig — der Rabatt wurde entfernt',
    'Загрузка…': 'Wird geladen…',
    'Ошибка загрузки данных': 'Daten konnten nicht geladen werden',
    'На главную': 'Zur Startseite',
    'Профиль': 'Profil',
    'Пополнить счёт': 'Guthaben aufladen',
    'Баланс': 'Guthaben',
    'звёзд': 'Sterne',
    '💬 Каждое сообщение персонажам стоит минимум 10 звёзд': '💬 Jede Nachricht an eine Figur kostet mindestens 10 Sterne',
    'Бесплатные звёзды': 'Gratis-Sterne',
    'Посмотрите рекламу и получите 1 звезду': 'Werbung ansehen und 1 Stern erhalten',
    'Только для зарегистрированных пользователей': 'Nur für registrierte Nutzer',
    'Смотреть рекламу': 'Werbung ansehen',
    'Промокод': 'Promocode',
    'Введи промокод — получи скидку или звёзды': 'Promocode eingeben — Rabatt oder Sterne sichern',
    'Введи промокод': 'Promocode eingeben',
    'Только для зарегистрированных': 'Nur für registrierte Nutzer',
    'Убрать': 'Entfernen',
    'Применить': 'Anwenden',
    '🎉 Скидка {0}% применена к ценам ниже!': '🎉 {0} % Rabatt auf die Preise unten angewendet!',
    'Пакеты': 'Pakete',
    'Быстрая покупка': 'Schnellkauf',
    'руб.': 'RUB',
    '{0} звёзд': '{0} Sterne',
    '{0} ходов': '{0} Züge',
    '{0} руб./ход': '{0} RUB/Zug',
    'до {0} сообщений персонажам': 'bis zu {0} Nachrichten an Figuren',
    'от {0} за сообщение': 'ab {0} pro Nachricht',
    'Переход к оплате…': 'Weiter zur Zahlung…',
    'Купить': 'Kaufen',
    'Войдите для покупки': 'Zum Kaufen anmelden',
    'Пополняя счёт, вы соглашаетесь с условиями оказания услуг, размещёнными в': 'Mit dem Aufladen deines Guthabens akzeptierst du die Nutzungsbedingungen aus der',
    'Пользовательском соглашении': 'Nutzungsvereinbarung',
    'История платежей': 'Zahlungsverlauf',
    '+{0} звёзд': '+{0} Sterne',

    /* AuthorsPage */
    '{0} — отличная возможность начать монетизировать своё творчество. Создавай увлекательные истории, в которые будут играть тысячи пользователей по всему миру.': '{0} ist deine Chance, mit deiner Kreativität Geld zu verdienen. Schreibe packende Geschichten, die Tausende Spieler weltweit erleben.',
    'Стать автором — AI Novel': 'Autor werden — AI Novel',
    'Стань автором интерактивных новелл с ИИ': 'Werde Autor interaktiver Visual Novels mit KI',
    'Начать создавать': 'Jetzt loslegen',
    'Узнать больше': 'Mehr erfahren',
    'Твой творческий потенциал — твой доход': 'Dein kreatives Potenzial — dein Einkommen',
    'Каждая успешная новелла приносит автору': 'Jede erfolgreiche Visual Novel bringt dem Autor',
    '20% от дохода': '20 % der Einnahmen',
    'и': 'und',
    '20 000 звёзд': '20 000 Sterne',
    'за каждую опубликованную новеллу. Чем популярнее твоя история — тем больше заработок.': 'für jede veröffentlichte Novel. Je beliebter deine Geschichte, desto höher dein Verdienst.',
    'от дохода': 'der Einnahmen',
    'за публикацию': 'pro Veröffentlichung',
    'тыс. пользователей': 'Tsd. Nutzer',
    'поддержка': 'Support',
    'Преимущества': 'Vorteile',
    'Почему авторы выбирают {0}': 'Warum Autoren {0} wählen',
    'Мы создали все условия, чтобы ты мог полностью сосредоточиться на творчестве': 'Wir kümmern uns um den Rest, damit du dich ganz aufs Schreiben konzentrieren kannst',
    'Выгодные условия': 'Attraktive Konditionen',
    'Получай 20% от дохода и 20 000 звёзд за каждую опубликованную новеллу. Чем популярнее твой контент — тем выше твой заработок без ограничений.': 'Erhalte 20 % der Einnahmen und 20 000 Sterne für jede veröffentlichte Novel. Je beliebter deine Inhalte, desto mehr verdienst du — ohne Obergrenze.',
    'Обучение и поддержка': 'Einarbeitung und Support',
    'Расскажем, научим и поможем разобраться с конструктором. Персональное сопровождение до выхода твоей первой новеллы.': 'Wir zeigen dir alles und helfen dir, den Editor zu meistern. Persönliche Begleitung bis zur Veröffentlichung deiner ersten Novel.',
    'Современные инструменты': 'Moderne Werkzeuge',
    'Предоставим доступ к удобному конструктору и всем необходимым сервисам для создания интерактивных новелл.': 'Du bekommst Zugang zu einem komfortablen Editor und allen Diensten, die du für interaktive Novels brauchst.',
    'Творческое сообщество': 'Kreative Community',
    'Присоединяйся к сообществу авторов {0}. Обменивайся опытом, получай обратную связь и вдохновляйся работами коллег.': 'Werde Teil der Autoren-Community von {0}. Tausche dich aus, hol dir Feedback und lass dich von den Werken anderer inspirieren.',
    'Прозрачные правила': 'Klare Regeln',
    'Чёткие и понятные условия сотрудничества. Никаких скрытых комиссий — ты всегда знаешь, сколько зарабатываешь.': 'Klare, verständliche Konditionen. Keine versteckten Gebühren — du weißt immer genau, was du verdienst.',
    'Быстрый старт': 'Schneller Start',
    'Уже через пару недель ты можешь опубликовать свою первую новеллу. Мы сопровождаем автора на каждом этапе.': 'Schon in wenigen Wochen kannst du deine erste Novel veröffentlichen. Wir begleiten dich bei jedem Schritt.',
    'Требования': 'Anforderungen',
    'Кого мы ищем': 'Wen wir suchen',
    'Мы ценим творческих людей, готовых учиться и развиваться': 'Wir schätzen kreative Menschen, die lernen und wachsen wollen',
    'Грамотность': 'Sprachgefühl',
    'Умение писать грамотно и складно — основа любой истории. Мы ценим чистый язык и выразительный стиль.': 'Sauberes, flüssiges Schreiben ist das Rückgrat jeder Geschichte. Wir schätzen klare Sprache und ausdrucksstarken Stil.',
    'Адекватность': 'Verlässlichkeit',
    'Умение работать в команде, принимать обратную связь и конструктивно общаться — ключ к успешному сотрудничеству.': 'Teamfähigkeit, Offenheit für Feedback und konstruktive Kommunikation machen die Zusammenarbeit erfolgreich.',
    'Желание учиться': 'Lernbereitschaft',
    'Готовность разобраться с конструктором и освоить новые инструменты. ПК или ноутбук обязателен для работы.': 'Bereitschaft, dich in den Editor einzuarbeiten und neue Tools zu lernen. Ein PC oder Laptop ist Voraussetzung.',
    'Мы поможем!': 'Wir helfen dir!',
    'Полная поддержка на протяжении всего времени': 'Volle Unterstützung von Anfang bis Ende',
    'Расскажем и покажем, как работает конструктор': 'Wir erklären und zeigen dir, wie der Editor funktioniert',
    'Научим создавать интерактивные ветвления': 'Wir bringen dir interaktive Verzweigungen bei',
    'Предоставим доступ ко всем сервисам': 'Wir geben dir Zugang zu allen Diensten',
    'Сопроводим до выхода новеллы': 'Wir begleiten dich bis zur Veröffentlichung',
    'Поддержим на каждом этапе': 'Wir unterstützen dich in jeder Phase',
    'Готов начать свой путь автора?': 'Bereit für deinen Weg als Autor?',
    'Напиши нам — ответим в течение 24 часов': 'Schreib uns — wir antworten innerhalb von 24 Stunden',
    'Заполнить форму': 'Formular ausfüllen',

    /* ProductionNovelPlay */
    'Читать далее': 'Weiterlesen',
    'Новелла не найдена': 'Novel nicht gefunden',
    'Ошибка загрузки': 'Ladefehler',
    'Только зарегистрированные пользователи могут лайкать новеллы.': 'Nur registrierte Nutzer können Novels liken.',
    'Только зарегистрированные пользователи могут оставлять комментарии.': 'Nur registrierte Nutzer können Kommentare schreiben.',
    'Только зарегистрированные пользователи могут ставить лайки.': 'Nur registrierte Nutzer können liken.',
    'Только зарегистрированные пользователи могут отвечать на комментарии.': 'Nur registrierte Nutzer können auf Kommentare antworten.',
    'Удалить новеллу? Это действие нельзя отменить.': 'Diese Novel löschen? Das lässt sich nicht rückgängig machen.',
    'Ошибка при удалении новеллы.': 'Novel konnte nicht gelöscht werden.',
    'Удаление…': 'Wird gelöscht…',
    'Поиск': 'Suche',
    'Играй в интерактивную новеллу «{0}» с ИИ-персонажами на {1}.': 'Spiele die interaktive Novel „{0}“ mit KI-Figuren auf {1}.',
    'Убрать лайк': 'Nicht mehr liken',
    'Нравится': 'Gefällt mir',
    'Играть': 'Spielen',
    'Комментарии': 'Kommentare',
    'Напишите комментарий…': 'Schreib einen Kommentar…',
    'Отправка…': 'Wird gesendet…',
    'Отправить': 'Senden',
    'Пока нет комментариев. Будьте первым!': 'Noch keine Kommentare. Sei der Erste!',
    'Ответить': 'Antworten',
    'Удалить': 'Löschen',
    'Ответить {0}…': 'Antwort an {0}…',
    'Отмена': 'Abbrechen',
    '▲ Скрыть ответы': '▲ Antworten ausblenden',
    '▼ Показать ответы ({0})': '▼ Antworten anzeigen ({0})',
    'Ошибка': 'Fehler',

    /* LibraryNovelDetail */
    'Ошибка при загрузке новеллы': 'Novel konnte nicht geladen werden',
    'Биография успешно обновлена': 'Biografie aktualisiert',
    'Удалить новеллу из библиотеки?': 'Diese Novel aus der Bibliothek entfernen?',
    'Новелла удалена из библиотеки': 'Novel aus der Bibliothek entfernt',
    'В библиотеку': 'Zur Bibliothek',
    'Начать новую игру? Текущий прогресс будет сброшен.': 'Neues Spiel starten? Dein aktueller Fortschritt wird zurückgesetzt.',
    'Играй в интерактивную новеллу «{0}» с персонажами на основе искусственного интеллекта.': 'Spiele die interaktive Novel „{0}“ mit Figuren auf Basis künstlicher Intelligenz.',
    'Библиотека': 'Bibliothek',
    'Биография персонажа': 'Biografie deiner Figur',
    'Имя персонажа': 'Name der Figur',
    'Введите имя…': 'Namen eingeben…',
    'Биография': 'Biografie',
    'Расскажите о своём персонаже…': 'Erzähl von deiner Figur…',
    'Сохранить': 'Speichern',
    'Имя': 'Name',
    'Не задано': 'Nicht angegeben',
    'Не задана': 'Nicht angegeben',
    'Редактировать': 'Bearbeiten',
    'Продолжить': 'Fortsetzen',
    'Сохранения': 'Spielstände',
    'Новая игра': 'Neues Spiel',
    'Сохранений не найдено': 'Keine Spielstände vorhanden',
    'Загрузить': 'Laden',

    /* SearchPage */
    'Ошибка при загрузке новелл': 'Novels konnten nicht geladen werden',
    'Каталог новелл — AI Novel': 'Novel-Katalog — AI Novel',
    'Каталог интерактивных визуальных новелл с ИИ. Выбирай и играй в новеллы, где персонажи отвечают с помощью искусственного интеллекта.': 'Ein Katalog interaktiver Visual Novels mit KI. Wähle eine Geschichte und spiele — die Figuren antworten dir dank künstlicher Intelligenz.',
    'AI Novel — каталог интерактивных новелл': 'AI Novel — Katalog interaktiver Novels',
    'Поиск новелл': 'Novels suchen',
    'Название': 'Titel',
    'Поиск по названию…': 'Nach Titel suchen…',
    'Сортировка': 'Sortierung',
    'Популярные': 'Beliebt',
    'Старые': 'Älteste',
    'Новые': 'Neueste',
    'Сбросить': 'Zurücksetzen',
    'Новеллы не найдены': 'Keine Novels gefunden',

    /* LibraryPage */
    'Ошибка при загрузке библиотеки': 'Bibliothek konnte nicht geladen werden',
    'Моя библиотека': 'Meine Bibliothek',
    'Библиотека ваших интерактивных новелл. Возобновляйте прохождение, управляйте сохранениями и следите за историей своих игр.': 'Deine persönliche Bibliothek interaktiver Novels. Mach da weiter, wo du aufgehört hast, verwalte deine Spielstände und behalte deinen Verlauf im Blick.',
    'В вашей библиотеке пока нет новелл': 'Deine Bibliothek ist noch leer',

    /* NovelCard */
    'Только зарегистрированные пользователи могут лайкать новеллы. Пожалуйста, создайте аккаунт.': 'Nur registrierte Nutzer können Novels liken. Bitte erstelle ein Konto.',
  },

  french: {
    /* PaymentPage */
    'Промокод не найден': 'Code promo introuvable',
    '+{0} звёзд зачислено!': '+{0} étoiles créditées !',
    'Реклама недоступна. Попробуйте позже.': 'La publicité est indisponible. Réessayez plus tard.',
    'Не удалось запустить рекламу': 'Impossible de lancer la publicité',
    'Нет доступной рекламы. Попробуйте позже.': 'Aucune publicité disponible pour le moment. Réessayez plus tard.',
    '+{0} звёзд! Спасибо за просмотр.': "+{0} étoiles ! Merci d'avoir regardé.",
    'Не удалось начислить звёзды': 'Impossible de créditer les étoiles',
    'Промокод больше не действителен — скидка сброшена': "Ce code promo n'est plus valable — la remise a été annulée",
    'Загрузка…': 'Chargement…',
    'Ошибка загрузки данных': 'Échec du chargement des données',
    'На главную': 'Accueil',
    'Профиль': 'Profil',
    'Пополнить счёт': 'Recharger le compte',
    'Баланс': 'Solde',
    'звёзд': 'étoiles',
    '💬 Каждое сообщение персонажам стоит минимум 10 звёзд': '💬 Chaque message envoyé à un personnage coûte au moins 10 étoiles',
    'Бесплатные звёзды': 'Étoiles gratuites',
    'Посмотрите рекламу и получите 1 звезду': 'Regardez une publicité et recevez 1 étoile',
    'Только для зарегистрированных пользователей': 'Réservé aux utilisateurs inscrits',
    'Смотреть рекламу': 'Voir la publicité',
    'Промокод': 'Code promo',
    'Введи промокод — получи скидку или звёзды': 'Saisis un code promo — obtiens une remise ou des étoiles',
    'Введи промокод': 'Saisis un code promo',
    'Только для зарегистрированных': 'Réservé aux inscrits',
    'Убрать': 'Retirer',
    'Применить': 'Appliquer',
    '🎉 Скидка {0}% применена к ценам ниже!': '🎉 Remise de {0} % appliquée aux prix ci-dessous !',
    'Пакеты': 'Forfaits',
    'Быстрая покупка': 'Achat rapide',
    'руб.': 'RUB',
    '{0} звёзд': '{0} étoiles',
    '{0} ходов': '{0} tours',
    '{0} руб./ход': '{0} RUB/tour',
    'до {0} сообщений персонажам': "jusqu'à {0} messages aux personnages",
    'от {0} за сообщение': 'dès {0} par message',
    'Переход к оплате…': 'Redirection vers le paiement…',
    'Купить': 'Acheter',
    'Войдите для покупки': 'Connectez-vous pour acheter',
    'Пополняя счёт, вы соглашаетесь с условиями оказания услуг, размещёнными в': 'En rechargeant votre compte, vous acceptez les conditions de service énoncées dans les',
    'Пользовательском соглашении': "Conditions d'utilisation",
    'История платежей': 'Historique des paiements',
    '+{0} звёзд': '+{0} étoiles',

    /* AuthorsPage */
    '{0} — отличная возможность начать монетизировать своё творчество. Создавай увлекательные истории, в которые будут играть тысячи пользователей по всему миру.': "{0}, c'est l'occasion de monétiser votre créativité. Écrivez des histoires captivantes que des milliers de joueurs découvriront partout dans le monde.",
    'Стать автором — AI Novel': 'Devenir auteur — AI Novel',
    'Стань автором интерактивных новелл с ИИ': "Devenez auteur de romans interactifs propulsés par l'IA",
    'Начать создавать': 'Commencer à créer',
    'Узнать больше': 'En savoir plus',
    'Твой творческий потенциал — твой доход': 'Votre créativité, vos revenus',
    'Каждая успешная новелла приносит автору': 'Chaque roman à succès rapporte à son auteur',
    '20% от дохода': '20 % des revenus',
    'и': 'et',
    '20 000 звёзд': '20 000 étoiles',
    'за каждую опубликованную новеллу. Чем популярнее твоя история — тем больше заработок.': 'pour chaque roman publié. Plus votre histoire est populaire, plus vous gagnez.',
    'от дохода': 'des revenus',
    'за публикацию': 'par publication',
    'тыс. пользователей': "milliers d'utilisateurs",
    'поддержка': 'assistance',
    'Преимущества': 'Avantages',
    'Почему авторы выбирают {0}': 'Pourquoi les auteurs choisissent {0}',
    'Мы создали все условия, чтобы ты мог полностью сосредоточиться на творчестве': "Nous nous occupons du reste pour que vous puissiez vous consacrer entièrement à l'écriture",
    'Выгодные условия': 'Des conditions avantageuses',
    'Получай 20% от дохода и 20 000 звёзд за каждую опубликованную новеллу. Чем популярнее твой контент — тем выше твой заработок без ограничений.': 'Touchez 20 % des revenus et 20 000 étoiles pour chaque roman publié. Plus votre contenu est populaire, plus vous gagnez — sans plafond.',
    'Обучение и поддержка': 'Formation et accompagnement',
    'Расскажем, научим и поможем разобраться с конструктором. Персональное сопровождение до выхода твоей первой новеллы.': "Nous vous expliquons tout et vous aidons à maîtriser l'éditeur. Un accompagnement personnalisé jusqu'à la sortie de votre premier roman.",
    'Современные инструменты': 'Des outils modernes',
    'Предоставим доступ к удобному конструктору и всем необходимым сервисам для создания интерактивных новелл.': 'Vous accédez à un éditeur pratique et à tous les services nécessaires pour créer des romans interactifs.',
    'Творческое сообщество': 'Une communauté créative',
    'Присоединяйся к сообществу авторов {0}. Обменивайся опытом, получай обратную связь и вдохновляйся работами коллег.': 'Rejoignez la communauté des auteurs {0}. Échangez vos expériences, recevez des retours et inspirez-vous du travail des autres.',
    'Прозрачные правила': 'Des règles transparentes',
    'Чёткие и понятные условия сотрудничества. Никаких скрытых комиссий — ты всегда знаешь, сколько зарабатываешь.': 'Des conditions claires et compréhensibles. Aucun frais caché — vous savez toujours ce que vous gagnez.',
    'Быстрый старт': 'Un démarrage rapide',
    'Уже через пару недель ты можешь опубликовать свою первую новеллу. Мы сопровождаем автора на каждом этапе.': 'En quelques semaines seulement, vous pouvez publier votre premier roman. Nous vous accompagnons à chaque étape.',
    'Требования': 'Prérequis',
    'Кого мы ищем': 'Qui nous recherchons',
    'Мы ценим творческих людей, готовых учиться и развиваться': 'Nous apprécions les esprits créatifs prêts à apprendre et à progresser',
    'Грамотность': 'Maîtrise de la langue',
    'Умение писать грамотно и складно — основа любой истории. Мы ценим чистый язык и выразительный стиль.': 'Une écriture claire et fluide est la base de toute histoire. Nous apprécions une langue soignée et un style expressif.',
    'Адекватность': 'Un bon relationnel',
    'Умение работать в команде, принимать обратную связь и конструктивно общаться — ключ к успешному сотрудничеству.': "Travailler en équipe, accepter les retours et communiquer de façon constructive : la clé d'une collaboration réussie.",
    'Желание учиться': "L'envie d'apprendre",
    'Готовность разобраться с конструктором и освоить новые инструменты. ПК или ноутбук обязателен для работы.': "Prêt à explorer l'éditeur et à apprendre de nouveaux outils. Un PC ou un portable est indispensable.",
    'Мы поможем!': 'Nous sommes là pour vous !',
    'Полная поддержка на протяжении всего времени': 'Un accompagnement complet du début à la fin',
    'Расскажем и покажем, как работает конструктор': "Nous vous expliquons et vous montrons comment fonctionne l'éditeur",
    'Научим создавать интерактивные ветвления': 'Nous vous apprenons à créer des embranchements interactifs',
    'Предоставим доступ ко всем сервисам': 'Nous vous donnons accès à tous les services',
    'Сопроводим до выхода новеллы': "Nous vous accompagnons jusqu'à la sortie du roman",
    'Поддержим на каждом этапе': 'Nous vous soutenons à chaque étape',
    'Готов начать свой путь автора?': "Prêt à démarrer votre parcours d'auteur ?",
    'Напиши нам — ответим в течение 24 часов': 'Écrivez-nous — nous répondons sous 24 heures',
    'Заполнить форму': 'Remplir le formulaire',

    /* ProductionNovelPlay */
    'Читать далее': 'Lire la suite',
    'Новелла не найдена': 'Roman introuvable',
    'Ошибка загрузки': 'Erreur de chargement',
    'Только зарегистрированные пользователи могут лайкать новеллы.': 'Seuls les utilisateurs inscrits peuvent aimer un roman.',
    'Только зарегистрированные пользователи могут оставлять комментарии.': 'Seuls les utilisateurs inscrits peuvent laisser un commentaire.',
    'Только зарегистрированные пользователи могут ставить лайки.': 'Seuls les utilisateurs inscrits peuvent aimer.',
    'Только зарегистрированные пользователи могут отвечать на комментарии.': 'Seuls les utilisateurs inscrits peuvent répondre aux commentaires.',
    'Удалить новеллу? Это действие нельзя отменить.': 'Supprimer ce roman ? Cette action est irréversible.',
    'Ошибка при удалении новеллы.': 'Échec de la suppression du roman.',
    'Удаление…': 'Suppression…',
    'Поиск': 'Recherche',
    'Играй в интерактивную новеллу «{0}» с ИИ-персонажами на {1}.': "Jouez au roman interactif « {0} » avec des personnages animés par l'IA sur {1}.",
    'Убрать лайк': 'Ne plus aimer',
    'Нравится': "J'aime",
    'Играть': 'Jouer',
    'Комментарии': 'Commentaires',
    'Напишите комментарий…': 'Écrire un commentaire…',
    'Отправка…': 'Envoi…',
    'Отправить': 'Envoyer',
    'Пока нет комментариев. Будьте первым!': "Aucun commentaire pour l'instant. Soyez le premier !",
    'Ответить': 'Répondre',
    'Удалить': 'Supprimer',
    'Ответить {0}…': 'Répondre à {0}…',
    'Отмена': 'Annuler',
    '▲ Скрыть ответы': '▲ Masquer les réponses',
    '▼ Показать ответы ({0})': '▼ Afficher les réponses ({0})',
    'Ошибка': 'Erreur',

    /* LibraryNovelDetail */
    'Ошибка при загрузке новеллы': 'Échec du chargement du roman',
    'Биография успешно обновлена': 'Biographie mise à jour',
    'Удалить новеллу из библиотеки?': 'Retirer ce roman de votre bibliothèque ?',
    'Новелла удалена из библиотеки': 'Roman retiré de votre bibliothèque',
    'В библиотеку': 'Vers la bibliothèque',
    'Начать новую игру? Текущий прогресс будет сброшен.': 'Commencer une nouvelle partie ? Votre progression actuelle sera réinitialisée.',
    'Играй в интерактивную новеллу «{0}» с персонажами на основе искусственного интеллекта.': "Jouez au roman interactif « {0} » avec des personnages animés par l'intelligence artificielle.",
    'Библиотека': 'Bibliothèque',
    'Биография персонажа': 'Biographie du personnage',
    'Имя персонажа': 'Nom du personnage',
    'Введите имя…': 'Saisissez un nom…',
    'Биография': 'Biographie',
    'Расскажите о своём персонаже…': 'Parlez-nous de votre personnage…',
    'Сохранить': 'Enregistrer',
    'Имя': 'Nom',
    'Не задано': 'Non défini',
    'Не задана': 'Non définie',
    'Редактировать': 'Modifier',
    'Продолжить': 'Continuer',
    'Сохранения': 'Sauvegardes',
    'Новая игра': 'Nouvelle partie',
    'Сохранений не найдено': 'Aucune sauvegarde',
    'Загрузить': 'Charger',

    /* SearchPage */
    'Ошибка при загрузке новелл': 'Échec du chargement des romans',
    'Каталог новелл — AI Novel': 'Catalogue de romans — AI Novel',
    'Каталог интерактивных визуальных новелл с ИИ. Выбирай и играй в новеллы, где персонажи отвечают с помощью искусственного интеллекта.': "Le catalogue des romans visuels interactifs avec IA. Choisissez une histoire et jouez : les personnages vous répondent grâce à l'intelligence artificielle.",
    'AI Novel — каталог интерактивных новелл': 'AI Novel — catalogue de romans interactifs',
    'Поиск новелл': 'Rechercher un roman',
    'Название': 'Titre',
    'Поиск по названию…': 'Rechercher par titre…',
    'Сортировка': 'Tri',
    'Популярные': 'Populaires',
    'Старые': 'Les plus anciens',
    'Новые': 'Les plus récents',
    'Сбросить': 'Réinitialiser',
    'Новеллы не найдены': 'Aucun roman trouvé',

    /* LibraryPage */
    'Ошибка при загрузке библиотеки': 'Échec du chargement de la bibliothèque',
    'Моя библиотека': 'Ma bibliothèque',
    'Библиотека ваших интерактивных новелл. Возобновляйте прохождение, управляйте сохранениями и следите за историей своих игр.': "Votre bibliothèque de romans interactifs. Reprenez là où vous vous êtes arrêté, gérez vos sauvegardes et suivez l'historique de vos parties.",
    'В вашей библиотеке пока нет новелл': 'Votre bibliothèque est encore vide',

    /* NovelCard */
    'Только зарегистрированные пользователи могут лайкать новеллы. Пожалуйста, создайте аккаунт.': 'Seuls les utilisateurs inscrits peuvent aimer un roman. Créez un compte, sʼil vous plaît.',
  },

  spanish: {
    /* PaymentPage */
    'Промокод не найден': 'Código promocional no encontrado',
    '+{0} звёзд зачислено!': '¡+{0} estrellas acreditadas!',
    'Реклама недоступна. Попробуйте позже.': 'La publicidad no está disponible. Inténtalo más tarde.',
    'Не удалось запустить рекламу': 'No se pudo iniciar el anuncio',
    'Нет доступной рекламы. Попробуйте позже.': 'No hay anuncios disponibles ahora mismo. Inténtalo más tarde.',
    '+{0} звёзд! Спасибо за просмотр.': '¡+{0} estrellas! Gracias por verlo.',
    'Не удалось начислить звёзды': 'No se pudieron acreditar las estrellas',
    'Промокод больше не действителен — скидка сброшена': 'Este código ya no es válido: se ha quitado el descuento',
    'Загрузка…': 'Cargando…',
    'Ошибка загрузки данных': 'Error al cargar los datos',
    'На главную': 'Inicio',
    'Профиль': 'Perfil',
    'Пополнить счёт': 'Recargar saldo',
    'Баланс': 'Saldo',
    'звёзд': 'estrellas',
    '💬 Каждое сообщение персонажам стоит минимум 10 звёзд': '💬 Cada mensaje a un personaje cuesta al menos 10 estrellas',
    'Бесплатные звёзды': 'Estrellas gratis',
    'Посмотрите рекламу и получите 1 звезду': 'Mira un anuncio y consigue 1 estrella',
    'Только для зарегистрированных пользователей': 'Solo para usuarios registrados',
    'Смотреть рекламу': 'Ver anuncio',
    'Промокод': 'Código promocional',
    'Введи промокод — получи скидку или звёзды': 'Introduce un código y consigue descuento o estrellas',
    'Введи промокод': 'Introduce un código',
    'Только для зарегистрированных': 'Solo usuarios registrados',
    'Убрать': 'Quitar',
    'Применить': 'Aplicar',
    '🎉 Скидка {0}% применена к ценам ниже!': '🎉 ¡Descuento del {0}% aplicado a los precios de abajo!',
    'Пакеты': 'Paquetes',
    'Быстрая покупка': 'Compra rápida',
    'руб.': 'RUB',
    '{0} звёзд': '{0} estrellas',
    '{0} ходов': '{0} turnos',
    '{0} руб./ход': '{0} RUB/turno',
    'до {0} сообщений персонажам': 'hasta {0} mensajes a personajes',
    'от {0} за сообщение': 'desde {0} por mensaje',
    'Переход к оплате…': 'Redirigiendo al pago…',
    'Купить': 'Comprar',
    'Войдите для покупки': 'Inicia sesión para comprar',
    'Пополняя счёт, вы соглашаетесь с условиями оказания услуг, размещёнными в': 'Al recargar tu saldo, aceptas las condiciones del servicio establecidas en el',
    'Пользовательском соглашении': 'Acuerdo de usuario',
    'История платежей': 'Historial de pagos',
    '+{0} звёзд': '+{0} estrellas',

    /* AuthorsPage */
    '{0} — отличная возможность начать монетизировать своё творчество. Создавай увлекательные истории, в которые будут играть тысячи пользователей по всему миру.': '{0} es tu oportunidad de monetizar tu creatividad. Escribe historias apasionantes que jugarán miles de personas en todo el mundo.',
    'Стать автором — AI Novel': 'Conviértete en autor — AI Novel',
    'Стань автором интерактивных новелл с ИИ': 'Conviértete en autor de novelas interactivas con IA',
    'Начать создавать': 'Empezar a crear',
    'Узнать больше': 'Saber más',
    'Твой творческий потенциал — твой доход': 'Tu creatividad, tus ingresos',
    'Каждая успешная новелла приносит автору': 'Cada novela de éxito le da a su autor',
    '20% от дохода': 'el 20% de los ingresos',
    'и': 'y',
    '20 000 звёзд': '20 000 estrellas',
    'за каждую опубликованную новеллу. Чем популярнее твоя история — тем больше заработок.': 'por cada novela publicada. Cuanto más popular sea tu historia, más ganas.',
    'от дохода': 'de los ingresos',
    'за публикацию': 'por publicación',
    'тыс. пользователей': 'mil usuarios',
    'поддержка': 'soporte',
    'Преимущества': 'Ventajas',
    'Почему авторы выбирают {0}': 'Por qué los autores eligen {0}',
    'Мы создали все условия, чтобы ты мог полностью сосредоточиться на творчестве': 'Nos ocupamos de todo lo demás para que solo tengas que pensar en escribir',
    'Выгодные условия': 'Condiciones ventajosas',
    'Получай 20% от дохода и 20 000 звёзд за каждую опубликованную новеллу. Чем популярнее твой контент — тем выше твой заработок без ограничений.': 'Gana el 20% de los ingresos y 20 000 estrellas por cada novela publicada. Cuanto más popular sea tu contenido, más ganas, sin límite.',
    'Обучение и поддержка': 'Formación y apoyo',
    'Расскажем, научим и поможем разобраться с конструктором. Персональное сопровождение до выхода твоей первой новеллы.': 'Te lo explicamos todo y te ayudamos a dominar el editor. Acompañamiento personal hasta el lanzamiento de tu primera novela.',
    'Современные инструменты': 'Herramientas modernas',
    'Предоставим доступ к удобному конструктору и всем необходимым сервисам для создания интерактивных новелл.': 'Te damos acceso a un editor cómodo y a todos los servicios necesarios para crear novelas interactivas.',
    'Творческое сообщество': 'Comunidad creativa',
    'Присоединяйся к сообществу авторов {0}. Обменивайся опытом, получай обратную связь и вдохновляйся работами коллег.': 'Únete a la comunidad de autores de {0}. Comparte experiencias, recibe comentarios e inspírate con el trabajo de otros.',
    'Прозрачные правила': 'Reglas transparentes',
    'Чёткие и понятные условия сотрудничества. Никаких скрытых комиссий — ты всегда знаешь, сколько зарабатываешь.': 'Condiciones claras y comprensibles. Sin comisiones ocultas: siempre sabes cuánto ganas.',
    'Быстрый старт': 'Arranque rápido',
    'Уже через пару недель ты можешь опубликовать свою первую новеллу. Мы сопровождаем автора на каждом этапе.': 'En un par de semanas puedes publicar tu primera novela. Te acompañamos en cada paso.',
    'Требования': 'Requisitos',
    'Кого мы ищем': 'A quién buscamos',
    'Мы ценим творческих людей, готовых учиться и развиваться': 'Valoramos a las personas creativas con ganas de aprender y crecer',
    'Грамотность': 'Buena escritura',
    'Умение писать грамотно и складно — основа любой истории. Мы ценим чистый язык и выразительный стиль.': 'Escribir con corrección y fluidez es la base de cualquier historia. Valoramos un lenguaje limpio y un estilo expresivo.',
    'Адекватность': 'Buen trato',
    'Умение работать в команде, принимать обратную связь и конструктивно общаться — ключ к успешному сотрудничеству.': 'Trabajar en equipo, aceptar comentarios y comunicarte de forma constructiva: la clave de una buena colaboración.',
    'Желание учиться': 'Ganas de aprender',
    'Готовность разобраться с конструктором и освоить новые инструменты. ПК или ноутбук обязателен для работы.': 'Disposición para manejar el editor y aprender herramientas nuevas. Se necesita un PC o portátil.',
    'Мы поможем!': '¡Te ayudamos!',
    'Полная поддержка на протяжении всего времени': 'Apoyo total de principio a fin',
    'Расскажем и покажем, как работает конструктор': 'Te explicamos y te enseñamos cómo funciona el editor',
    'Научим создавать интерактивные ветвления': 'Te enseñamos a crear ramificaciones interactivas',
    'Предоставим доступ ко всем сервисам': 'Te damos acceso a todos los servicios',
    'Сопроводим до выхода новеллы': 'Te acompañamos hasta el lanzamiento de la novela',
    'Поддержим на каждом этапе': 'Te apoyamos en cada etapa',
    'Готов начать свой путь автора?': '¿Listo para empezar tu camino como autor?',
    'Напиши нам — ответим в течение 24 часов': 'Escríbenos: respondemos en 24 horas',
    'Заполнить форму': 'Rellenar el formulario',

    /* ProductionNovelPlay */
    'Читать далее': 'Leer más',
    'Новелла не найдена': 'Novela no encontrada',
    'Ошибка загрузки': 'Error de carga',
    'Только зарегистрированные пользователи могут лайкать новеллы.': 'Solo los usuarios registrados pueden dar me gusta a las novelas.',
    'Только зарегистрированные пользователи могут оставлять комментарии.': 'Solo los usuarios registrados pueden dejar comentarios.',
    'Только зарегистрированные пользователи могут ставить лайки.': 'Solo los usuarios registrados pueden dar me gusta.',
    'Только зарегистрированные пользователи могут отвечать на комментарии.': 'Solo los usuarios registrados pueden responder a los comentarios.',
    'Удалить новеллу? Это действие нельзя отменить.': '¿Eliminar esta novela? Esta acción no se puede deshacer.',
    'Ошибка при удалении новеллы.': 'Error al eliminar la novela.',
    'Удаление…': 'Eliminando…',
    'Поиск': 'Buscar',
    'Играй в интерактивную новеллу «{0}» с ИИ-персонажами на {1}.': 'Juega a la novela interactiva «{0}» con personajes de IA en {1}.',
    'Убрать лайк': 'Quitar me gusta',
    'Нравится': 'Me gusta',
    'Играть': 'Jugar',
    'Комментарии': 'Comentarios',
    'Напишите комментарий…': 'Escribe un comentario…',
    'Отправка…': 'Enviando…',
    'Отправить': 'Enviar',
    'Пока нет комментариев. Будьте первым!': 'Aún no hay comentarios. ¡Sé el primero!',
    'Ответить': 'Responder',
    'Удалить': 'Eliminar',
    'Ответить {0}…': 'Responder a {0}…',
    'Отмена': 'Cancelar',
    '▲ Скрыть ответы': '▲ Ocultar respuestas',
    '▼ Показать ответы ({0})': '▼ Mostrar respuestas ({0})',
    'Ошибка': 'Error',

    /* LibraryNovelDetail */
    'Ошибка при загрузке новеллы': 'Error al cargar la novela',
    'Биография успешно обновлена': 'Biografía actualizada',
    'Удалить новеллу из библиотеки?': '¿Quitar esta novela de tu biblioteca?',
    'Новелла удалена из библиотеки': 'Novela quitada de tu biblioteca',
    'В библиотеку': 'A la biblioteca',
    'Начать новую игру? Текущий прогресс будет сброшен.': '¿Empezar una partida nueva? Se perderá tu progreso actual.',
    'Играй в интерактивную новеллу «{0}» с персонажами на основе искусственного интеллекта.': 'Juega a la novela interactiva «{0}» con personajes basados en inteligencia artificial.',
    'Библиотека': 'Biblioteca',
    'Биография персонажа': 'Biografía del personaje',
    'Имя персонажа': 'Nombre del personaje',
    'Введите имя…': 'Escribe un nombre…',
    'Биография': 'Biografía',
    'Расскажите о своём персонаже…': 'Cuéntanos sobre tu personaje…',
    'Сохранить': 'Guardar',
    'Имя': 'Nombre',
    'Не задано': 'Sin definir',
    'Не задана': 'Sin definir',
    'Редактировать': 'Editar',
    'Продолжить': 'Continuar',
    'Сохранения': 'Partidas guardadas',
    'Новая игра': 'Partida nueva',
    'Сохранений не найдено': 'No hay partidas guardadas',
    'Загрузить': 'Cargar',

    /* SearchPage */
    'Ошибка при загрузке новелл': 'Error al cargar las novelas',
    'Каталог новелл — AI Novel': 'Catálogo de novelas — AI Novel',
    'Каталог интерактивных визуальных новелл с ИИ. Выбирай и играй в новеллы, где персонажи отвечают с помощью искусственного интеллекта.': 'Catálogo de novelas visuales interactivas con IA. Elige una historia y juega: los personajes te responden con inteligencia artificial.',
    'AI Novel — каталог интерактивных новелл': 'AI Novel: catálogo de novelas interactivas',
    'Поиск новелл': 'Buscar novelas',
    'Название': 'Título',
    'Поиск по названию…': 'Buscar por título…',
    'Сортировка': 'Ordenar por',
    'Популярные': 'Populares',
    'Старые': 'Más antiguas',
    'Новые': 'Más recientes',
    'Сбросить': 'Restablecer',
    'Новеллы не найдены': 'No se encontraron novelas',

    /* LibraryPage */
    'Ошибка при загрузке библиотеки': 'Error al cargar la biblioteca',
    'Моя библиотека': 'Mi biblioteca',
    'Библиотека ваших интерактивных новелл. Возобновляйте прохождение, управляйте сохранениями и следите за историей своих игр.': 'Tu biblioteca de novelas interactivas. Retoma la partida donde la dejaste, gestiona tus guardados y revisa el historial de tus juegos.',
    'В вашей библиотеке пока нет новелл': 'Tu biblioteca aún está vacía',

    /* NovelCard */
    'Только зарегистрированные пользователи могут лайкать новеллы. Пожалуйста, создайте аккаунт.': 'Solo los usuarios registrados pueden dar me gusta a las novelas. Crea una cuenta, por favor.',
  },

  italian: {
    /* PaymentPage */
    'Промокод не найден': 'Codice promozionale non trovato',
    '+{0} звёзд зачислено!': '+{0} stelle accreditate!',
    'Реклама недоступна. Попробуйте позже.': 'La pubblicità non è disponibile. Riprova più tardi.',
    'Не удалось запустить рекламу': 'Impossibile avviare la pubblicità',
    'Нет доступной рекламы. Попробуйте позже.': 'Nessuna pubblicità disponibile al momento. Riprova più tardi.',
    '+{0} звёзд! Спасибо за просмотр.': '+{0} stelle! Grazie per aver guardato.',
    'Не удалось начислить звёзды': 'Impossibile accreditare le stelle',
    'Промокод больше не действителен — скидка сброшена': 'Questo codice non è più valido — lo sconto è stato rimosso',
    'Загрузка…': 'Caricamento…',
    'Ошибка загрузки данных': 'Errore nel caricamento dei dati',
    'На главную': 'Home',
    'Профиль': 'Profilo',
    'Пополнить счёт': 'Ricarica il saldo',
    'Баланс': 'Saldo',
    'звёзд': 'stelle',
    '💬 Каждое сообщение персонажам стоит минимум 10 звёзд': '💬 Ogni messaggio a un personaggio costa almeno 10 stelle',
    'Бесплатные звёзды': 'Stelle gratis',
    'Посмотрите рекламу и получите 1 звезду': 'Guarda una pubblicità e ricevi 1 stella',
    'Только для зарегистрированных пользователей': 'Solo per utenti registrati',
    'Смотреть рекламу': 'Guarda la pubblicità',
    'Промокод': 'Codice promozionale',
    'Введи промокод — получи скидку или звёзды': 'Inserisci un codice — ottieni uno sconto o delle stelle',
    'Введи промокод': 'Inserisci un codice',
    'Только для зарегистрированных': 'Solo utenti registrati',
    'Убрать': 'Rimuovi',
    'Применить': 'Applica',
    '🎉 Скидка {0}% применена к ценам ниже!': '🎉 Sconto del {0}% applicato ai prezzi qui sotto!',
    'Пакеты': 'Pacchetti',
    'Быстрая покупка': 'Acquisto rapido',
    'руб.': 'RUB',
    '{0} звёзд': '{0} stelle',
    '{0} ходов': '{0} turni',
    '{0} руб./ход': '{0} RUB/turno',
    'до {0} сообщений персонажам': 'fino a {0} messaggi ai personaggi',
    'от {0} за сообщение': 'da {0} a messaggio',
    'Переход к оплате…': 'Vai al pagamento…',
    'Купить': 'Acquista',
    'Войдите для покупки': 'Accedi per acquistare',
    'Пополняя счёт, вы соглашаетесь с условиями оказания услуг, размещёнными в': 'Ricaricando il saldo accetti le condizioni di servizio riportate nel',
    'Пользовательском соглашении': "Contratto d'uso",
    'История платежей': 'Cronologia dei pagamenti',
    '+{0} звёзд': '+{0} stelle',

    /* AuthorsPage */
    '{0} — отличная возможность начать монетизировать своё творчество. Создавай увлекательные истории, в которые будут играть тысячи пользователей по всему миру.': "{0} è l'occasione per iniziare a monetizzare la tua creatività. Scrivi storie avvincenti che migliaia di giocatori in tutto il mondo vivranno in prima persona.",
    'Стать автором — AI Novel': 'Diventa autore — AI Novel',
    'Стань автором интерактивных новелл с ИИ': "Diventa autore di novel interattive con l'IA",
    'Начать создавать': 'Inizia a creare',
    'Узнать больше': 'Scopri di più',
    'Твой творческий потенциал — твой доход': 'La tua creatività, il tuo guadagno',
    'Каждая успешная новелла приносит автору': "Ogni novel di successo porta all'autore",
    '20% от дохода': 'il 20% dei ricavi',
    'и': 'e',
    '20 000 звёзд': '20.000 stelle',
    'за каждую опубликованную новеллу. Чем популярнее твоя история — тем больше заработок.': 'per ogni novel pubblicata. Più la tua storia è popolare, più guadagni.',
    'от дохода': 'dei ricavi',
    'за публикацию': 'per pubblicazione',
    'тыс. пользователей': 'mila utenti',
    'поддержка': 'assistenza',
    'Преимущества': 'Vantaggi',
    'Почему авторы выбирают {0}': 'Perché gli autori scelgono {0}',
    'Мы создали все условия, чтобы ты мог полностью сосредоточиться на творчестве': 'Pensiamo noi a tutto il resto, così puoi concentrarti solo sulla scrittura',
    'Выгодные условия': 'Condizioni vantaggiose',
    'Получай 20% от дохода и 20 000 звёзд за каждую опубликованную новеллу. Чем популярнее твой контент — тем выше твой заработок без ограничений.': 'Guadagna il 20% dei ricavi e 20.000 stelle per ogni novel pubblicata. Più i tuoi contenuti piacciono, più guadagni, senza limiti.',
    'Обучение и поддержка': 'Formazione e supporto',
    'Расскажем, научим и поможем разобраться с конструктором. Персональное сопровождение до выхода твоей первой новеллы.': "Ti spieghiamo tutto e ti aiutiamo a padroneggiare l'editor. Affiancamento personale fino all'uscita della tua prima novel.",
    'Современные инструменты': 'Strumenti moderni',
    'Предоставим доступ к удобному конструктору и всем необходимым сервисам для создания интерактивных новелл.': "Ti diamo accesso a un editor comodo e a tutti i servizi necessari per creare novel interattive.",
    'Творческое сообщество': 'Una community creativa',
    'Присоединяйся к сообществу авторов {0}. Обменивайся опытом, получай обратную связь и вдохновляйся работами коллег.': 'Entra nella community degli autori di {0}. Scambia esperienze, ricevi feedback e lasciati ispirare dai lavori degli altri.',
    'Прозрачные правила': 'Regole trasparenti',
    'Чёткие и понятные условия сотрудничества. Никаких скрытых комиссий — ты всегда знаешь, сколько зарабатываешь.': 'Condizioni di collaborazione chiare e comprensibili. Nessuna commissione nascosta: sai sempre quanto guadagni.',
    'Быстрый старт': 'Partenza veloce',
    'Уже через пару недель ты можешь опубликовать свою первую новеллу. Мы сопровождаем автора на каждом этапе.': 'In un paio di settimane puoi pubblicare la tua prima novel. Ti seguiamo in ogni fase.',
    'Требования': 'Requisiti',
    'Кого мы ищем': 'Chi cerchiamo',
    'Мы ценим творческих людей, готовых учиться и развиваться': 'Diamo valore alle persone creative, pronte a imparare e a crescere',
    'Грамотность': 'Padronanza della lingua',
    'Умение писать грамотно и складно — основа любой истории. Мы ценим чистый язык и выразительный стиль.': 'Scrivere in modo corretto e scorrevole è la base di ogni storia. Apprezziamo una lingua pulita e uno stile espressivo.',
    'Адекватность': 'Affidabilità',
    'Умение работать в команде, принимать обратную связь и конструктивно общаться — ключ к успешному сотрудничеству.': 'Lavorare in squadra, accogliere i feedback e comunicare in modo costruttivo: la chiave di una collaborazione riuscita.',
    'Желание учиться': 'Voglia di imparare',
    'Готовность разобраться с конструктором и освоить новые инструменты. ПК или ноутбук обязателен для работы.': "Voglia di imparare l'editor e nuovi strumenti. Un PC o un portatile è indispensabile.",
    'Мы поможем!': 'Ti aiutiamo noi!',
    'Полная поддержка на протяжении всего времени': "Supporto completo dall'inizio alla fine",
    'Расскажем и покажем, как работает конструктор': "Ti spieghiamo e ti mostriamo come funziona l'editor",
    'Научим создавать интерактивные ветвления': 'Ti insegniamo a creare ramificazioni interattive',
    'Предоставим доступ ко всем сервисам': 'Ti diamo accesso a tutti i servizi',
    'Сопроводим до выхода новеллы': "Ti accompagniamo fino all'uscita della novel",
    'Поддержим на каждом этапе': 'Ti sosteniamo in ogni fase',
    'Готов начать свой путь автора?': 'Pronto a iniziare il tuo percorso da autore?',
    'Напиши нам — ответим в течение 24 часов': 'Scrivici: rispondiamo entro 24 ore',
    'Заполнить форму': 'Compila il modulo',

    /* ProductionNovelPlay */
    'Читать далее': 'Leggi tutto',
    'Новелла не найдена': 'Novel non trovata',
    'Ошибка загрузки': 'Errore di caricamento',
    'Только зарегистрированные пользователи могут лайкать новеллы.': 'Solo gli utenti registrati possono mettere mi piace alle novel.',
    'Только зарегистрированные пользователи могут оставлять комментарии.': 'Solo gli utenti registrati possono lasciare commenti.',
    'Только зарегистрированные пользователи могут ставить лайки.': 'Solo gli utenti registrati possono mettere mi piace.',
    'Только зарегистрированные пользователи могут отвечать на комментарии.': 'Solo gli utenti registrati possono rispondere ai commenti.',
    'Удалить новеллу? Это действие нельзя отменить.': "Eliminare questa novel? L'azione non può essere annullata.",
    'Ошибка при удалении новеллы.': "Errore durante l'eliminazione della novel.",
    'Удаление…': 'Eliminazione…',
    'Поиск': 'Cerca',
    'Играй в интерактивную новеллу «{0}» с ИИ-персонажами на {1}.': "Gioca alla novel interattiva «{0}» con personaggi guidati dall'IA su {1}.",
    'Убрать лайк': 'Togli mi piace',
    'Нравится': 'Mi piace',
    'Играть': 'Gioca',
    'Комментарии': 'Commenti',
    'Напишите комментарий…': 'Scrivi un commento…',
    'Отправка…': 'Invio…',
    'Отправить': 'Invia',
    'Пока нет комментариев. Будьте первым!': 'Ancora nessun commento. Sii il primo!',
    'Ответить': 'Rispondi',
    'Удалить': 'Elimina',
    'Ответить {0}…': 'Rispondi a {0}…',
    'Отмена': 'Annulla',
    '▲ Скрыть ответы': '▲ Nascondi risposte',
    '▼ Показать ответы ({0})': '▼ Mostra risposte ({0})',
    'Ошибка': 'Errore',

    /* LibraryNovelDetail */
    'Ошибка при загрузке новеллы': 'Errore nel caricamento della novel',
    'Биография успешно обновлена': 'Biografia aggiornata',
    'Удалить новеллу из библиотеки?': 'Rimuovere questa novel dalla libreria?',
    'Новелла удалена из библиотеки': 'Novel rimossa dalla libreria',
    'В библиотеку': 'Vai alla libreria',
    'Начать новую игру? Текущий прогресс будет сброшен.': 'Iniziare una nuova partita? I progressi attuali andranno persi.',
    'Играй в интерактивную новеллу «{0}» с персонажами на основе искусственного интеллекта.': "Gioca alla novel interattiva «{0}» con personaggi basati sull'intelligenza artificiale.",
    'Библиотека': 'Libreria',
    'Биография персонажа': 'Biografia del personaggio',
    'Имя персонажа': 'Nome del personaggio',
    'Введите имя…': 'Inserisci un nome…',
    'Биография': 'Biografia',
    'Расскажите о своём персонаже…': 'Raccontaci del tuo personaggio…',
    'Сохранить': 'Salva',
    'Имя': 'Nome',
    'Не задано': 'Non impostato',
    'Не задана': 'Non impostata',
    'Редактировать': 'Modifica',
    'Продолжить': 'Continua',
    'Сохранения': 'Salvataggi',
    'Новая игра': 'Nuova partita',
    'Сохранений не найдено': 'Nessun salvataggio',
    'Загрузить': 'Carica',

    /* SearchPage */
    'Ошибка при загрузке новелл': 'Errore nel caricamento delle novel',
    'Каталог новелл — AI Novel': 'Catalogo delle novel — AI Novel',
    'Каталог интерактивных визуальных новелл с ИИ. Выбирай и играй в новеллы, где персонажи отвечают с помощью искусственного интеллекта.': "Il catalogo delle visual novel interattive con IA. Scegli una storia e gioca: i personaggi ti rispondono grazie all'intelligenza artificiale.",
    'AI Novel — каталог интерактивных новелл': 'AI Novel — catalogo di novel interattive',
    'Поиск новелл': 'Cerca una novel',
    'Название': 'Titolo',
    'Поиск по названию…': 'Cerca per titolo…',
    'Сортировка': 'Ordina per',
    'Популярные': 'Popolari',
    'Старые': 'Meno recenti',
    'Новые': 'Più recenti',
    'Сбросить': 'Reimposta',
    'Новеллы не найдены': 'Nessuna novel trovata',

    /* LibraryPage */
    'Ошибка при загрузке библиотеки': 'Errore nel caricamento della libreria',
    'Моя библиотека': 'La mia libreria',
    'Библиотека ваших интерактивных новелл. Возобновляйте прохождение, управляйте сохранениями и следите за историей своих игр.': 'La tua libreria di novel interattive. Riprendi da dove avevi lasciato, gestisci i salvataggi e segui la cronologia delle partite.',
    'В вашей библиотеке пока нет новелл': 'La tua libreria è ancora vuota',

    /* NovelCard */
    'Только зарегистрированные пользователи могут лайкать новеллы. Пожалуйста, создайте аккаунт.': 'Solo gli utenti registrati possono mettere mi piace alle novel. Crea un account.',
  },

  polish: {
    /* PaymentPage */
    'Промокод не найден': 'Nie znaleziono kodu promocyjnego',
    '+{0} звёзд зачислено!': 'Dodano +{0} gwiazdek!',
    'Реклама недоступна. Попробуйте позже.': 'Reklamy są niedostępne. Spróbuj później.',
    'Не удалось запустить рекламу': 'Nie udało się uruchomić reklamy',
    'Нет доступной рекламы. Попробуйте позже.': 'Brak dostępnych reklam. Spróbuj później.',
    '+{0} звёзд! Спасибо за просмотр.': '+{0} gwiazdek! Dzięki za obejrzenie.',
    'Не удалось начислить звёзды': 'Nie udało się przyznać gwiazdek',
    'Промокод больше не действителен — скидка сброшена': 'Ten kod promocyjny jest już nieaktywny — rabat został usunięty',
    'Загрузка…': 'Ładowanie…',
    'Ошибка загрузки данных': 'Błąd wczytywania danych',
    'На главную': 'Strona główna',
    'Профиль': 'Profil',
    'Пополнить счёт': 'Doładuj konto',
    'Баланс': 'Saldo',
    'звёзд': 'gwiazdek',
    '💬 Каждое сообщение персонажам стоит минимум 10 звёзд': '💬 Każda wiadomość do postaci kosztuje co najmniej 10 gwiazdek',
    'Бесплатные звёзды': 'Darmowe gwiazdki',
    'Посмотрите рекламу и получите 1 звезду': 'Obejrzyj reklamę i odbierz 1 gwiazdkę',
    'Только для зарегистрированных пользователей': 'Tylko dla zarejestrowanych użytkowników',
    'Смотреть рекламу': 'Obejrzyj reklamę',
    'Промокод': 'Kod promocyjny',
    'Введи промокод — получи скидку или звёзды': 'Wpisz kod promocyjny — zgarnij rabat lub gwiazdki',
    'Введи промокод': 'Wpisz kod promocyjny',
    'Только для зарегистрированных': 'Tylko dla zarejestrowanych',
    'Убрать': 'Usuń',
    'Применить': 'Zastosuj',
    '🎉 Скидка {0}% применена к ценам ниже!': '🎉 Rabat {0}% naliczony do cen poniżej!',
    'Пакеты': 'Pakiety',
    'Быстрая покупка': 'Szybki zakup',
    'руб.': 'RUB',
    '{0} звёзд': '{0} gwiazdek',
    '{0} ходов': '{0} tur',
    '{0} руб./ход': '{0} RUB/tura',
    'до {0} сообщений персонажам': 'do {0} wiadomości do postaci',
    'от {0} за сообщение': 'od {0} za wiadomość',
    'Переход к оплате…': 'Przechodzenie do płatności…',
    'Купить': 'Kup',
    'Войдите для покупки': 'Zaloguj się, aby kupić',
    'Пополняя счёт, вы соглашаетесь с условиями оказания услуг, размещёнными в': 'Doładowując konto, akceptujesz warunki świadczenia usług określone w',
    'Пользовательском соглашении': 'Regulaminie',
    'История платежей': 'Historia płatności',
    '+{0} звёзд': '+{0} gwiazdek',

    /* AuthorsPage */
    '{0} — отличная возможность начать монетизировать своё творчество. Создавай увлекательные истории, в которые будут играть тысячи пользователей по всему миру.': '{0} to szansa, by zacząć zarabiać na swojej twórczości. Twórz wciągające historie, w które zagrają tysiące osób na całym świecie.',
    'Стать автором — AI Novel': 'Zostań autorem — AI Novel',
    'Стань автором интерактивных новелл с ИИ': 'Zostań autorem interaktywnych powieści z AI',
    'Начать создавать': 'Zacznij tworzyć',
    'Узнать больше': 'Dowiedz się więcej',
    'Твой творческий потенциал — твой доход': 'Twoja kreatywność — twój zarobek',
    'Каждая успешная новелла приносит автору': 'Każda udana powieść daje autorowi',
    '20% от дохода': '20% przychodu',
    'и': 'i',
    '20 000 звёзд': '20 000 gwiazdek',
    'за каждую опубликованную новеллу. Чем популярнее твоя история — тем больше заработок.': 'za każdą opublikowaną powieść. Im popularniejsza historia, tym większy zarobek.',
    'от дохода': 'przychodu',
    'за публикацию': 'za publikację',
    'тыс. пользователей': 'tys. użytkowników',
    'поддержка': 'wsparcie',
    'Преимущества': 'Korzyści',
    'Почему авторы выбирают {0}': 'Dlaczego autorzy wybierają {0}',
    'Мы создали все условия, чтобы ты мог полностью сосредоточиться на творчестве': 'Resztą zajmujemy się my — ty skup się wyłącznie na tworzeniu',
    'Выгодные условия': 'Korzystne warunki',
    'Получай 20% от дохода и 20 000 звёзд за каждую опубликованную новеллу. Чем популярнее твой контент — тем выше твой заработок без ограничений.': 'Zgarniaj 20% przychodu i 20 000 gwiazdek za każdą opublikowaną powieść. Im popularniejsze treści, tym większy zarobek — bez limitu.',
    'Обучение и поддержка': 'Szkolenie i wsparcie',
    'Расскажем, научим и поможем разобраться с конструктором. Персональное сопровождение до выхода твоей первой новеллы.': 'Wszystko wytłumaczymy i pomożemy opanować kreator. Osobiste wsparcie aż do premiery pierwszej powieści.',
    'Современные инструменты': 'Nowoczesne narzędzia',
    'Предоставим доступ к удобному конструктору и всем необходимым сервисам для создания интерактивных новелл.': 'Dajemy dostęp do wygodnego kreatora i wszystkich narzędzi potrzebnych do tworzenia interaktywnych powieści.',
    'Творческое сообщество': 'Twórcza społeczność',
    'Присоединяйся к сообществу авторов {0}. Обменивайся опытом, получай обратную связь и вдохновляйся работами коллег.': 'Dołącz do społeczności autorów {0}. Wymieniaj się doświadczeniem, zbieraj opinie i inspiruj się pracami innych.',
    'Прозрачные правила': 'Przejrzyste zasady',
    'Чёткие и понятные условия сотрудничества. Никаких скрытых комиссий — ты всегда знаешь, сколько зарабатываешь.': 'Jasne i zrozumiałe warunki współpracy. Żadnych ukrytych prowizji — zawsze wiesz, ile zarabiasz.',
    'Быстрый старт': 'Szybki start',
    'Уже через пару недель ты можешь опубликовать свою первую новеллу. Мы сопровождаем автора на каждом этапе.': 'Pierwszą powieść możesz opublikować już po kilku tygodniach. Jesteśmy z tobą na każdym etapie.',
    'Требования': 'Wymagania',
    'Кого мы ищем': 'Kogo szukamy',
    'Мы ценим творческих людей, готовых учиться и развиваться': 'Cenimy kreatywnych ludzi, gotowych się uczyć i rozwijać',
    'Грамотность': 'Poprawność językowa',
    'Умение писать грамотно и складно — основа любой истории. Мы ценим чистый язык и выразительный стиль.': 'Poprawne i płynne pisanie to podstawa każdej historii. Cenimy czysty język i wyrazisty styl.',
    'Адекватность': 'Dobra współpraca',
    'Умение работать в команде, принимать обратную связь и конструктивно общаться — ключ к успешному сотрудничеству.': 'Praca w zespole, otwartość na uwagi i konstruktywna komunikacja to klucz do udanej współpracy.',
    'Желание учиться': 'Chęć nauki',
    'Готовность разобраться с конструктором и освоить новые инструменты. ПК или ноутбук обязателен для работы.': 'Gotowość, by poznać kreator i opanować nowe narzędzia. Komputer lub laptop jest niezbędny.',
    'Мы поможем!': 'Pomożemy!',
    'Полная поддержка на протяжении всего времени': 'Pełne wsparcie od początku do końca',
    'Расскажем и покажем, как работает конструктор': 'Pokażemy i wytłumaczymy, jak działa kreator',
    'Научим создавать интерактивные ветвления': 'Nauczymy tworzyć interaktywne rozgałęzienia',
    'Предоставим доступ ко всем сервисам': 'Damy dostęp do wszystkich usług',
    'Сопроводим до выхода новеллы': 'Poprowadzimy aż do premiery powieści',
    'Поддержим на каждом этапе': 'Wesprzemy na każdym etapie',
    'Готов начать свой путь автора?': 'Gotów zacząć swoją drogę autora?',
    'Напиши нам — ответим в течение 24 часов': 'Napisz do nas — odpowiemy w ciągu 24 godzin',
    'Заполнить форму': 'Wypełnij formularz',

    /* ProductionNovelPlay */
    'Читать далее': 'Czytaj dalej',
    'Новелла не найдена': 'Nie znaleziono powieści',
    'Ошибка загрузки': 'Błąd wczytywania',
    'Только зарегистрированные пользователи могут лайкать новеллы.': 'Tylko zarejestrowani użytkownicy mogą polubić powieść.',
    'Только зарегистрированные пользователи могут оставлять комментарии.': 'Tylko zarejestrowani użytkownicy mogą komentować.',
    'Только зарегистрированные пользователи могут ставить лайки.': 'Tylko zarejestrowani użytkownicy mogą dawać polubienia.',
    'Только зарегистрированные пользователи могут отвечать на комментарии.': 'Tylko zarejestrowani użytkownicy mogą odpowiadać na komentarze.',
    'Удалить новеллу? Это действие нельзя отменить.': 'Usunąć tę powieść? Tej operacji nie można cofnąć.',
    'Ошибка при удалении новеллы.': 'Błąd podczas usuwania powieści.',
    'Удаление…': 'Usuwanie…',
    'Поиск': 'Szukaj',
    'Играй в интерактивную новеллу «{0}» с ИИ-персонажами на {1}.': 'Zagraj w interaktywną powieść „{0}” z postaciami sterowanymi przez AI na {1}.',
    'Убрать лайк': 'Cofnij polubienie',
    'Нравится': 'Lubię to',
    'Играть': 'Graj',
    'Комментарии': 'Komentarze',
    'Напишите комментарий…': 'Napisz komentarz…',
    'Отправка…': 'Wysyłanie…',
    'Отправить': 'Wyślij',
    'Пока нет комментариев. Будьте первым!': 'Nie ma jeszcze komentarzy. Bądź pierwszy!',
    'Ответить': 'Odpowiedz',
    'Удалить': 'Usuń',
    'Ответить {0}…': 'Odpowiedz {0}…',
    'Отмена': 'Anuluj',
    '▲ Скрыть ответы': '▲ Ukryj odpowiedzi',
    '▼ Показать ответы ({0})': '▼ Pokaż odpowiedzi ({0})',
    'Ошибка': 'Błąd',

    /* LibraryNovelDetail */
    'Ошибка при загрузке новеллы': 'Błąd wczytywania powieści',
    'Биография успешно обновлена': 'Biografia zaktualizowana',
    'Удалить новеллу из библиотеки?': 'Usunąć tę powieść z biblioteki?',
    'Новелла удалена из библиотеки': 'Powieść usunięta z biblioteki',
    'В библиотеку': 'Do biblioteki',
    'Начать новую игру? Текущий прогресс будет сброшен.': 'Zacząć nową grę? Obecny postęp zostanie skasowany.',
    'Играй в интерактивную новеллу «{0}» с персонажами на основе искусственного интеллекта.': 'Zagraj w interaktywną powieść „{0}” z postaciami opartymi na sztucznej inteligencji.',
    'Библиотека': 'Biblioteka',
    'Биография персонажа': 'Biografia postaci',
    'Имя персонажа': 'Imię postaci',
    'Введите имя…': 'Wpisz imię…',
    'Биография': 'Biografia',
    'Расскажите о своём персонаже…': 'Opowiedz o swojej postaci…',
    'Сохранить': 'Zapisz',
    'Имя': 'Imię',
    'Не задано': 'Nie podano',
    'Не задана': 'Nie podano',
    'Редактировать': 'Edytuj',
    'Продолжить': 'Kontynuuj',
    'Сохранения': 'Zapisy',
    'Новая игра': 'Nowa gra',
    'Сохранений не найдено': 'Brak zapisów',
    'Загрузить': 'Wczytaj',

    /* SearchPage */
    'Ошибка при загрузке новелл': 'Błąd wczytywania powieści',
    'Каталог новелл — AI Novel': 'Katalog powieści — AI Novel',
    'Каталог интерактивных визуальных новелл с ИИ. Выбирай и играй в новеллы, где персонажи отвечают с помощью искусственного интеллекта.': 'Katalog interaktywnych powieści wizualnych z AI. Wybierz historię i graj — postacie odpowiadają dzięki sztucznej inteligencji.',
    'AI Novel — каталог интерактивных новелл': 'AI Novel — katalog interaktywnych powieści',
    'Поиск новелл': 'Wyszukaj powieść',
    'Название': 'Tytuł',
    'Поиск по названию…': 'Szukaj po tytule…',
    'Сортировка': 'Sortowanie',
    'Популярные': 'Popularne',
    'Старые': 'Najstarsze',
    'Новые': 'Najnowsze',
    'Сбросить': 'Wyczyść',
    'Новеллы не найдены': 'Nie znaleziono powieści',

    /* LibraryPage */
    'Ошибка при загрузке библиотеки': 'Błąd wczytywania biblioteki',
    'Моя библиотека': 'Moja biblioteka',
    'Библиотека ваших интерактивных новелл. Возобновляйте прохождение, управляйте сохранениями и следите за историей своих игр.': 'Twoja biblioteka interaktywnych powieści. Wracaj do przerwanej rozgrywki, zarządzaj zapisami i śledź historię swoich gier.',
    'В вашей библиотеке пока нет новелл': 'Twoja biblioteka jest jeszcze pusta',

    /* NovelCard */
    'Только зарегистрированные пользователи могут лайкать новеллы. Пожалуйста, создайте аккаунт.': 'Tylko zarejestrowani użytkownicy mogą polubić powieść. Załóż konto.',
  },

  portuguese: {
    /* PaymentPage */
    'Промокод не найден': 'Código promocional não encontrado',
    '+{0} звёзд зачислено!': '+{0} estrelas adicionadas!',
    'Реклама недоступна. Попробуйте позже.': 'Anúncios indisponíveis. Tente novamente mais tarde.',
    'Не удалось запустить рекламу': 'Não foi possível iniciar o anúncio',
    'Нет доступной рекламы. Попробуйте позже.': 'Nenhum anúncio disponível agora. Tente novamente mais tarde.',
    '+{0} звёзд! Спасибо за просмотр.': '+{0} estrelas! Obrigado por assistir.',
    'Не удалось начислить звёзды': 'Não foi possível creditar suas estrelas',
    'Промокод больше не действителен — скидка сброшена': 'Este código promocional não é mais válido — o desconto foi removido',
    'Загрузка…': 'Carregando…',
    'Ошибка загрузки данных': 'Falha ao carregar os dados',
    'На главную': 'Início',
    'Профиль': 'Perfil',
    'Пополнить счёт': 'Recarregar saldo',
    'Баланс': 'Saldo',
    'звёзд': 'estrelas',
    '💬 Каждое сообщение персонажам стоит минимум 10 звёзд': '💬 Cada mensagem para um personagem custa no mínimo 10 estrelas',
    'Бесплатные звёзды': 'Estrelas grátis',
    'Посмотрите рекламу и получите 1 звезду': 'Assista a um anúncio e ganhe 1 estrela',
    'Только для зарегистрированных пользователей': 'Somente para usuários cadastrados',
    'Смотреть рекламу': 'Assistir anúncio',
    'Промокод': 'Código promocional',
    'Введи промокод — получи скидку или звёзды': 'Digite um código promocional — ganhe desconto ou estrelas',
    'Введи промокод': 'Digite o código promocional',
    'Только для зарегистрированных': 'Somente para cadastrados',
    'Убрать': 'Remover',
    'Применить': 'Aplicar',
    '🎉 Скидка {0}% применена к ценам ниже!': '🎉 Desconto de {0}% aplicado aos preços abaixo!',
    'Пакеты': 'Pacotes',
    'Быстрая покупка': 'Compra rápida',
    'руб.': 'RUB',
    '{0} звёзд': '{0} estrelas',
    '{0} ходов': '{0} jogadas',
    '{0} руб./ход': '{0} RUB/jogada',
    'до {0} сообщений персонажам': 'até {0} mensagens para personagens',
    'от {0} за сообщение': 'a partir de {0} por mensagem',
    'Переход к оплате…': 'Indo para o pagamento…',
    'Купить': 'Comprar',
    'Войдите для покупки': 'Entre para comprar',
    'Пополняя счёт, вы соглашаетесь с условиями оказания услуг, размещёнными в': 'Ao recarregar seu saldo, você concorda com os termos de prestação de serviço descritos no',
    'Пользовательском соглашении': 'Contrato de Usuário',
    'История платежей': 'Histórico de pagamentos',
    '+{0} звёзд': '+{0} estrelas',

    /* AuthorsPage */
    '{0} — отличная возможность начать монетизировать своё творчество. Создавай увлекательные истории, в которые будут играть тысячи пользователей по всему миру.': '{0} é a sua chance de começar a ganhar dinheiro com sua criatividade. Escreva histórias envolventes que milhares de jogadores ao redor do mundo vão viver.',
    'Стать автором — AI Novel': 'Torne-se autor — AI Novel',
    'Стань автором интерактивных новелл с ИИ': 'Torne-se autor de novels interativas com IA',
    'Начать создавать': 'Começar a criar',
    'Узнать больше': 'Saiba mais',
    'Твой творческий потенциал — твой доход': 'Sua criatividade, sua renda',
    'Каждая успешная новелла приносит автору': 'Cada novel de sucesso rende ao autor',
    '20% от дохода': '20% da receita',
    'и': 'e',
    '20 000 звёзд': '20.000 estrelas',
    'за каждую опубликованную новеллу. Чем популярнее твоя история — тем больше заработок.': 'por cada novel publicada. Quanto mais popular a sua história, mais você ganha.',
    'от дохода': 'da receita',
    'за публикацию': 'por publicação',
    'тыс. пользователей': 'mil usuários',
    'поддержка': 'suporte',
    'Преимущества': 'Vantagens',
    'Почему авторы выбирают {0}': 'Por que os autores escolhem a {0}',
    'Мы создали все условия, чтобы ты мог полностью сосредоточиться на творчестве': 'Nós cuidamos de todo o resto para você se concentrar só em escrever',
    'Выгодные условия': 'Condições vantajosas',
    'Получай 20% от дохода и 20 000 звёзд за каждую опубликованную новеллу. Чем популярнее твой контент — тем выше твой заработок без ограничений.': 'Ganhe 20% da receita mais 20.000 estrelas por cada novel publicada. Quanto mais popular o seu trabalho, mais você ganha — sem limite.',
    'Обучение и поддержка': 'Treinamento e suporte',
    'Расскажем, научим и поможем разобраться с конструктором. Персональное сопровождение до выхода твоей первой новеллы.': 'Mostramos o caminho e ajudamos você a dominar o editor. Acompanhamento personalizado até o lançamento da sua primeira novel.',
    'Современные инструменты': 'Ferramentas modernas',
    'Предоставим доступ к удобному конструктору и всем необходимым сервисам для создания интерактивных новелл.': 'Você tem acesso a um editor prático e a todos os serviços necessários para criar novels interativas.',
    'Творческое сообщество': 'Uma comunidade criativa',
    'Присоединяйся к сообществу авторов {0}. Обменивайся опытом, получай обратную связь и вдохновляйся работами коллег.': 'Entre para a comunidade de autores da {0}. Troque ideias, receba feedback e se inspire no trabalho dos colegas.',
    'Прозрачные правила': 'Regras transparentes',
    'Чёткие и понятные условия сотрудничества. Никаких скрытых комиссий — ты всегда знаешь, сколько зарабатываешь.': 'Condições claras e diretas. Sem taxas ocultas — você sempre sabe exatamente quanto ganha.',
    'Быстрый старт': 'Início rápido',
    'Уже через пару недель ты можешь опубликовать свою первую новеллу. Мы сопровождаем автора на каждом этапе.': 'Em poucas semanas você já pode publicar sua primeira novel. Estamos com você em cada etapa.',
    'Требования': 'Requisitos',
    'Кого мы ищем': 'Quem estamos procurando',
    'Мы ценим творческих людей, готовых учиться и развиваться': 'Valorizamos pessoas criativas, com vontade de aprender e crescer',
    'Грамотность': 'Boa escrita',
    'Умение писать грамотно и складно — основа любой истории. Мы ценим чистый язык и выразительный стиль.': 'Escrever bem e com fluidez é a base de qualquer história. Valorizamos uma linguagem limpa e um estilo expressivo.',
    'Адекватность': 'Fácil de trabalhar junto',
    'Умение работать в команде, принимать обратную связь и конструктивно общаться — ключ к успешному сотрудничеству.': 'Trabalho em equipe, abertura a feedback e comunicação construtiva são a chave para uma boa parceria.',
    'Желание учиться': 'Vontade de aprender',
    'Готовность разобраться с конструктором и освоить новые инструменты. ПК или ноутбук обязателен для работы.': 'Disposição para explorar o editor e aprender novas ferramentas. É obrigatório ter um computador ou notebook.',
    'Мы поможем!': 'Nós ajudamos você!',
    'Полная поддержка на протяжении всего времени': 'Suporte completo do início ao fim',
    'Расскажем и покажем, как работает конструктор': 'Mostramos como o editor funciona',
    'Научим создавать интерактивные ветвления': 'Ensinamos a criar histórias com ramificações',
    'Предоставим доступ ко всем сервисам': 'Damos acesso a todos os serviços',
    'Сопроводим до выхода новеллы': 'Acompanhamos você até o lançamento',
    'Поддержим на каждом этапе': 'Apoiamos você em cada etapa',
    'Готов начать свой путь автора?': 'Pronto para começar sua jornada como autor?',
    'Напиши нам — ответим в течение 24 часов': 'Fale com a gente — respondemos em até 24 horas',
    'Заполнить форму': 'Preencher o formulário',

    /* ProductionNovelPlay */
    'Читать далее': 'Ler mais',
    'Новелла не найдена': 'Novel não encontrada',
    'Ошибка загрузки': 'Erro ao carregar',
    'Только зарегистрированные пользователи могут лайкать новеллы.': 'Só usuários cadastrados podem curtir novels.',
    'Только зарегистрированные пользователи могут оставлять комментарии.': 'Só usuários cadastrados podem comentar.',
    'Только зарегистрированные пользователи могут ставить лайки.': 'Só usuários cadastrados podem curtir.',
    'Только зарегистрированные пользователи могут отвечать на комментарии.': 'Só usuários cadastrados podem responder a comentários.',
    'Удалить новеллу? Это действие нельзя отменить.': 'Excluir esta novel? Essa ação não pode ser desfeita.',
    'Ошибка при удалении новеллы.': 'Falha ao excluir a novel.',
    'Удаление…': 'Excluindo…',
    'Поиск': 'Buscar',
    'Играй в интерактивную новеллу «{0}» с ИИ-персонажами на {1}.': 'Jogue a novel interativa “{0}” com personagens movidos por IA na {1}.',
    'Убрать лайк': 'Descurtir',
    'Нравится': 'Curtir',
    'Играть': 'Jogar',
    'Комментарии': 'Comentários',
    'Напишите комментарий…': 'Escreva um comentário…',
    'Отправка…': 'Enviando…',
    'Отправить': 'Enviar',
    'Пока нет комментариев. Будьте первым!': 'Ainda não há comentários. Seja o primeiro!',
    'Ответить': 'Responder',
    'Удалить': 'Excluir',
    'Ответить {0}…': 'Responder a {0}…',
    'Отмена': 'Cancelar',
    '▲ Скрыть ответы': '▲ Ocultar respostas',
    '▼ Показать ответы ({0})': '▼ Mostrar respostas ({0})',
    'Ошибка': 'Erro',

    /* LibraryNovelDetail */
    'Ошибка при загрузке новеллы': 'Falha ao carregar a novel',
    'Биография успешно обновлена': 'Biografia atualizada',
    'Удалить новеллу из библиотеки?': 'Remover esta novel da sua biblioteca?',
    'Новелла удалена из библиотеки': 'Novel removida da sua biblioteca',
    'В библиотеку': 'Para a biblioteca',
    'Начать новую игру? Текущий прогресс будет сброшен.': 'Começar um novo jogo? Seu progresso atual será apagado.',
    'Играй в интерактивную новеллу «{0}» с персонажами на основе искусственного интеллекта.': 'Jogue a novel interativa “{0}” com personagens movidos por inteligência artificial.',
    'Библиотека': 'Biblioteca',
    'Биография персонажа': 'Biografia do seu personagem',
    'Имя персонажа': 'Nome do personagem',
    'Введите имя…': 'Digite um nome…',
    'Биография': 'Biografia',
    'Расскажите о своём персонаже…': 'Conte sobre o seu personagem…',
    'Сохранить': 'Salvar',
    'Имя': 'Nome',
    'Не задано': 'Não definido',
    'Не задана': 'Não definida',
    'Редактировать': 'Editar',
    'Продолжить': 'Continuar',
    'Сохранения': 'Jogos salvos',
    'Новая игра': 'Novo jogo',
    'Сохранений не найдено': 'Nenhum jogo salvo ainda',
    'Загрузить': 'Carregar',

    /* SearchPage */
    'Ошибка при загрузке новелл': 'Falha ao carregar as novels',
    'Каталог новелл — AI Novel': 'Catálogo de novels — AI Novel',
    'Каталог интерактивных визуальных новелл с ИИ. Выбирай и играй в новеллы, где персонажи отвечают с помощью искусственного интеллекта.': 'Um catálogo de visual novels interativas com IA. Escolha uma história e jogue — cada personagem responde a você por meio de inteligência artificial.',
    'AI Novel — каталог интерактивных новелл': 'AI Novel — catálogo de novels interativas',
    'Поиск новелл': 'Encontre uma novel',
    'Название': 'Título',
    'Поиск по названию…': 'Buscar por título…',
    'Сортировка': 'Ordenar por',
    'Популярные': 'Populares',
    'Старые': 'Mais antigas',
    'Новые': 'Mais recentes',
    'Сбросить': 'Limpar',
    'Новеллы не найдены': 'Nenhuma novel encontrada',

    /* LibraryPage */
    'Ошибка при загрузке библиотеки': 'Falha ao carregar sua biblioteca',
    'Моя библиотека': 'Minha biblioteca',
    'Библиотека ваших интерактивных новелл. Возобновляйте прохождение, управляйте сохранениями и следите за историей своих игр.': 'Sua biblioteca pessoal de novels interativas. Continue de onde parou, gerencie seus jogos salvos e acompanhe seu histórico de jogo.',
    'В вашей библиотеке пока нет новелл': 'Sua biblioteca ainda está vazia',

    /* NovelCard */
    'Только зарегистрированные пользователи могут лайкать новеллы. Пожалуйста, создайте аккаунт.': 'Só usuários cadastrados podem curtir novels. Crie uma conta.',
  },
};

export default discovery;
